import React, { useEffect, useContext } from 'react'
import { useMsal } from '@azure/msal-react'
import { CNavItem, CContainer, CHeader, CHeaderNav, CAvatar, CCol, CNavLink } from '@coreui/react'
import Switch from 'react-switch'
import hmLogo from '../assets/images/IntegrationMontioring/H&M Group.svg'
import dark from '../assets/images/IntegrationMontioring/dark.svg'
import light from '../assets/images/IntegrationMontioring/light.svg'
import IM_Context from './Contexts/IM_Context/Im_Context'
import { getAppInsights } from '../services/TelemetryService'
import { SeverityLevel } from '@microsoft/applicationinsights-web'
import { fnBrowserDetect } from '../utils/utils'
import { environmentData } from '../environments/env'
import HamburgerMenu from './FlipCardComponent/HamburgerMenu'
import { appLogout } from '../services/logoutService'

const AppHeader = ({ userDetails, toggleClick, showBamHeader }) => {
  let runEnv = environmentData['run']
  const { instance } = useMsal()
  const { isDarkTheme, setIsDarkTheme } = useContext(IM_Context)
  const adminEmail = environmentData[runEnv]['dashboardAdminEmail']
  const toggleTheme = () => {
    setIsDarkTheme(!isDarkTheme)
    toggleClick(isDarkTheme)
  }
  let appInsights
  const handleLogout = (logoutType) => {
    if (logoutType === 'redirect') {
      appLogout()
    }
  }
  const getInitials = (user) => {
    return user
      .split(' ')
      .map((initial) => initial[0])
      .join('')
      .replace(/[\])}[{(]/g, '')
  }
  useEffect(() => {
    // Add anti-cache headers so that back button after logout does not resurrect a protected view.
    // These headers only affect same-page reload (best effort in SPA); service worker is not used.
    try {
      const noCacheMeta = document.createElement('meta')
      noCacheMeta.httpEquiv = 'Cache-Control'
      noCacheMeta.content = 'no-store, no-cache, must-revalidate, max-age=0'
      document.head.appendChild(noCacheMeta)
    } catch (e) {
      // ignore
    }
    appInsights = getAppInsights()
    appInsights.trackTrace({
      message:
        'User Name: ' +
        userDetails?.[0]?.userName +
        ' User Email: ' +
        userDetails?.[0]?.userEmail +
        ' Browser: ' +
        fnBrowserDetect(),
      severityLevel: SeverityLevel.Information,
    })

    return () => {
      // no inactivity listeners to remove here
    }
    // session timeout end
  }, [adminEmail])

  return (
    <CHeader position="sticky" className={`app ${isDarkTheme ? 'dark' : 'light'} im-cnt-wrap`}>
      <CContainer fluid>
        <CCol md={5}>
          <CHeaderNav className={`app ${isDarkTheme ? 'dark' : 'light'}`} d-none d-md-flex>
            <HamburgerMenu />
            <CNavItem className="py-1 sdf-sidemenu-icon me-3 ms-6 ">
              {/* <img
                src={HamburgerIcon}
                alt="hamburgerIcon"
                className="me-4"
                onClick={() => console.log('toggle')}
              /> */}
              <img src={hmLogo} alt="hmlogo" />
            </CNavItem>
          </CHeaderNav>
        </CCol>
        <CCol>
          <CHeaderNav>
            {showBamHeader ? (
              <CNavItem
                className={`app integration-monitoring-text ${isDarkTheme ? 'dark' : 'light'}`}
                font-style
                style={{ letterSpacing: 1.6 }}
              >
                Integration Message Tracker
              </CNavItem>
            ) : (
              <CNavItem
                className={`app integration-monitoring-text ${isDarkTheme ? 'dark' : 'light'}`}
                font-style
              >
                INTEGRATION MONITORING
              </CNavItem>
            )}
          </CHeaderNav>
        </CCol>
        <CCol className="d-flex justify-content-end">
          <CHeaderNav className="header-profile-avatar">
            {/* {!showBamHeader ? (
              <CNavItem className="d-flex align-items-center pe-2">
                <Switch
                  onChange={toggleTheme}
                  offColor="#808080"
                  onColor="#FFFFFF"
                  offHandleColor="#FFFFFF"
                  onHandleColor="#808080"
                  checked={isDarkTheme}
                  uncheckedIcon={
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',

                        paddingRight: 2,
                      }}
                    >
                      <img src={dark} alt="dark" />
                    </div>
                  }
                  checkedIcon={
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',

                        paddingRight: 2,
                      }}
                    >
                      <img src={light} alt="light" />
                    </div>
                  }
                  uncheckedHandleIcon={
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',

                        paddingRight: 2,
                      }}
                    >
                      <img src={light} alt="light" />
                    </div>
                  }
                  checkedHandleIcon={
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                      }}
                    >
                      <img src={dark} alt="light" />
                    </div>
                  }
                  className="react-switch"
                />
              </CNavItem>
            ) : (
              ''
            )} */}

            <CNavItem className="d-flex align-items-center pe-2">
              <CAvatar
                className={`app profileAvatar ${isDarkTheme ? 'light' : 'dark'}`}
                data-coreui-toggle="tooltip"
                data-coreui-placement="bottom"
                title={userDetails?.[0]?.userName}
                textColor="white"
              >
                {userDetails?.length > 0 && getInitials(userDetails?.[0]?.userName)}
              </CAvatar>
            </CNavItem>

            <CNavItem>
              <CNavLink onClick={() => handleLogout('redirect')} data-testid="logoutIcon">
                <CAvatar className={`app profileAvatar`} circleIcon>
                  <span className="logoutSpriteIcon"></span>
                </CAvatar>
              </CNavLink>
            </CNavItem>
          </CHeaderNav>
        </CCol>
      </CContainer>
    </CHeader>
  )
}
export default AppHeader
